import { Auth, Form } from '@livecontrol/core-ui';
import { Str } from '@livecontrol/core-utils';
import { User } from '@livecontrol/scheduler/model';
import { FormikProvider } from 'formik';
import qs from 'qs';
import type { ReactElement } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Store } from '../../store';
import { useForm } from './form';

const Content = (): ReactElement => {
  const { formik, loading, alert } = useForm();

  return (
    <>
      <Form.Alert show={alert.show} onClose={alert.hide}>
        {alert.message}
      </Form.Alert>

      <FormikProvider value={formik}>
        <Form>
          <Form.Group
            name='email'
            label='Email Address'
            controlProps={{
              autoFocus: true,
              maxLength: User.Constraints.EMAIL_MAX_LENGTH
            }}
          />

          <div className='d-flex align-items-center justify-content-between'>
            <Form.Submit className='btn-wide' loading={loading} size='lg'>
              Submit
            </Form.Submit>

            <Link className='font-size-13px' to='/login'>
              Back to Login
            </Link>
          </div>
        </Form>
      </FormikProvider>
    </>
  );
};

const Page = (): ReactElement => (
  <Auth.Layout>
    <Auth.Panel title='Forgot Password' className='x-light-theme'>
      <Content />
    </Auth.Panel>
  </Auth.Layout>
);

export const ForgotPassword = (): ReactElement => {
  const { me } = Store.User.useIdentity();

  const redirectTo =
    Str.normalize(qs.parse(window.location.search, { ignoreQueryPrefix: true }).redirect) ?? '/';

  // Is the client already authenticated?
  return me ? <Redirect to={redirectTo} /> : <Page />;
};
